import Link from 'next/link';
import { IconTemplate } from '@components/Icon/IconTemplate';
import { rem } from 'polished';
import styled from 'styled-components';
import { breakpoints, theme } from '../../styles/theme';

export const Item = styled.div`
    margin-bottom: ${rem(20)};
    width: 100%;

    @media (min-width: ${breakpoints.md}px) {
        display: flex;
        min-height: ${rem(185)};
    }
`;

export const Calendar = styled.div<{ isConference?: boolean }>`
    background: ${(prop) => (prop.isConference ? prop.theme.colors.primaryMedium : prop.theme.colors.primaryLight)};
    display: flex;
    flex-direction: column;
    padding: ${rem(15)} ${rem(10)};
    position: relative;

    @media (min-width: ${breakpoints.md}px) {
        width: ${rem(195)};
    }
`;

export const Topic = styled.div`
    border: 1px solid ${({ theme }) => theme.colors.border};
    padding: ${rem(20)};
    border-radius: ${rem(16)};
    position: relative;
    width: 100%;

    @media (min-width: ${breakpoints.sm}px) {
        padding: ${rem(30)};
    }

    @media (min-width: ${breakpoints.md}px) {
        display: flex;
        flex-direction: column;
    }
`;

export const TopicFirstRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-bottom: ${rem(15)};
    font-weight: ${({ theme }) => theme.fontWeights.textBold};

    .label {
        color: ${({ theme }) => theme.colors.white};
        font-size: ${({ theme }) => theme.fontSizes.textSmall};
        padding: ${rem(4)} ${rem(12)};
        font-weight: 400;
        margin-left: ${rem(10)};
        text-transform: uppercase;
        border-radius: ${rem(16)};
    }

    .conferenceLabel {
        background: ${({ theme }) => theme.colors.black};
    }

    .courseLabel {
        background: ${({ theme }) => theme.colors.dark};
    }
`;

export const TopicSecondRow = styled.div`
    padding-bottom: ${rem(25)};
`;

export const TopicThirdRow = styled.div`
    @media (min-width: ${breakpoints.sm}px) {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-end;
    }
`;

export const TopicTitle = styled.h3`
    font-size: ${({ theme }) => theme.fontSizes.h6};
    line-height: ${rem(24)};
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-family: ${({ theme }) => theme.fonts.fontSecondary};
    //color: ${({ theme }) => theme.colors.primary};
    background: none;
    padding: 0;
    border: none;
    cursor: pointer;
    text-align: left;
    text-decoration: none;
    display: inline-block;

    @media (min-width: ${breakpoints.sm}px) {
        width: 70%;
        font-size: ${({ theme }) => theme.fontSizes.h5};
        line-height: ${rem(30)};
    }
`;

export const TopicDescription = styled.p`
    line-clamp: 3;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    margin: 0;
    line-height: 1.75rem;
    color: ${({ theme }) => theme.colors.secondaryGrey};
    strong  {
        color: rgb(46,46,46) !important;
    }
`;

export const Lecturers = styled.div`
    display: flex;
    flex-wrap: wrap;
    max-width: 80%;
`;

export const Tags = styled.div`
    padding: ${rem(15)} 0;

    @media (min-width: ${breakpoints.md}px) {
        padding: 0;
    }
`;

export const TopicPlaces = styled.div`
    padding: ${rem(15)} 0;
    display: flex;
`;

export const TopicPlace = styled.div`
    color: ${({ theme }) => theme.colors.secondaryGrey};
`;


